import { useTenantFeatureSettings, isTenantFeatureKey } from '../features/TenantFeatureSettingsProvider';
import { useFlags } from './Backstage';
import { Flags } from './backstage.model';

export const useFeatures = (names: string | string[]) => {
  const namesAsArray = Array.isArray(names) ? names : Array(names);

  const backstageFlags = useFlags<Flags>(namesAsArray as Flags[]);

  const { effective: tenantSettings } = useTenantFeatureSettings();

  return namesAsArray.every(n => {
    if (!backstageFlags[n as Flags] === true) {
      return false;
    }

    if (isTenantFeatureKey(n)) {
      return tenantSettings[n];
    }

    return true;
  });
};
